{
  "eyebrow": "Planınızı onaylayın",
  "title": "Gözden geçirin ve yapılandırın.",
  "sub": "Faturalama döngüsünü veya planı yönetici panelinden istediğiniz zaman değiştirebilirsiniz.",
  "yourPlan": "Planınız",
  "changePlan": "Planı değiştir",
  "billing": "Faturalama döngüsü",
  "billingMonthLabel": "Aylık ödeme",
  "billingMonthDesc": "Esnek. İstediğiniz zaman iptal edin.",
  "billingYearLabel": "Yıllık ödeme",
  "billingYearDesc": "~17% indirim. Yılda bir kez faturalandırılır.",
  "addons": "Eklentiler",
  "addon": {
    "ssec": "Sosyal güvenlik (check-in/out@work)",
    "ssecDesc": "Yalnızca Belçika — otomatik Dimona bildirimi.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Şirket araçları için canlı GPS. +4 €/araç/ay.",
    "vehicles": "Araçlar",
    "projectAddon": "Proje yönetimi eklentisi",
    "projectAddonDesc": "Time Pro proje yönetimi özelliklerini açar (ek işler, planlama, taşeron yönetimi)."
  },
  "employees": {
    "title": "Kaç çalışan?",
    "active": "aktif kullanıcı",
    "popular": "Çoğu ekip {{n}} seçer"
  },
  "estimate": "Tahmini aylık maliyet",
  "estimateNote": "KDV hariç. Kullanıcı başı ücretler aktif çalışanlara göre faturalandırılır.",
  "estimateUnavailable": "Fiyat kataloğu kullanılamıyor. En güncel fiyatları yüklemek için tekrar deneyin."
}
